import { render, staticRenderFns } from "./couponRuleAdd.vue?vue&type=template&id=1b66d854&scoped=true"
import script from "./couponRuleAdd.vue?vue&type=script&lang=js"
export * from "./couponRuleAdd.vue?vue&type=script&lang=js"
import style0 from "./couponRuleAdd.vue?vue&type=style&index=0&id=1b66d854&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b66d854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b66d854')) {
      api.createRecord('1b66d854', component.options)
    } else {
      api.reload('1b66d854', component.options)
    }
    module.hot.accept("./couponRuleAdd.vue?vue&type=template&id=1b66d854&scoped=true", function () {
      api.rerender('1b66d854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/customerCoupone/customerCouponRule/couponRuleAdd.vue"
export default component.exports